export const EMPTY_STRING = '';

export const EMAIL_PUBLIC_KEY = 'rGGB-mNHLNgMx4BHA';
export const EMAIL_SERVICE_ID = 'service_bd4f6g6';
export const EMAIL_TEMPLATE_ID_BOOK_NOW = 'template_ubkx8pg';
export const EMAIL_TEMPLATE_ID_CALCULATION = 'template_28bbu6j';

export const DARK_BLACK = '#140101';
export const BEIGE = '#F8F6DF';
export const TRANSPARENT = 'transparent';

export const WINDOW_DATALAYER = window.dataLayer || [];
